function initialOrder() {
	return {
		order_by: 'name',
		order_dir: 'asc',
	};
}

export const state = () => ({
	groups: [],
	order: initialOrder(),
	search: null,
});

export const mutations = {
	setGroups(state: any, payload: any) {
		state.groups = payload;
	},

	setOrder(state: any, payload: object) {
		state.order = payload;
	},

	setSearch(state: any, payload: string | null) {
		state.search = payload;
	},
};

export const getters = {
	getGroups: (state: any) => state.groups,

	getOrder: (state: any) => state.order,

	getSearch: (state: any) => state.search,
};

export const actions = {
	addGroup(state: any, payload: any) {
		const company_uuid = this.$auth.user.company.uuid;

		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/company/${company_uuid}/head-hunting/groups`, payload)
				.then((res) => {
					const groups = JSON.parse(JSON.stringify(state.state.groups));

					groups.push(res.data);

					state.commit('setGroups', groups);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	deleteGroup(state: any, group_uuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete(`/api/company/head-hunting/groups/${group_uuid}`)
				.then((res) => {
					let groups = JSON.parse(JSON.stringify(state.state.groups));

					groups = groups.filter((group) => group.uuid !== group_uuid);

					state.commit('setGroups', groups);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getGroups(state: any, payload: any) {
		const company_uuid = this.$auth.user.company.uuid;

		let data = {
			search: state.state.search,
			...state.state.order,
		};

		// Delete empty keys from the posted data
		Object.keys(data).forEach((key) => !data[key] && delete data[key]);

		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/company/${company_uuid}/head-hunting/groups`, { params: data })
				.then((res) => {
					state.commit('setGroups', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateGroup(state: any, payload: any) {
		const { group_uuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.put(`/api/company/head-hunting/groups/${group_uuid}`, data)
				.then((res) => {
					let groups = JSON.parse(JSON.stringify(state.state.groups));

					groups = groups.map((group) => {
						if (group.uuid === group_uuid) {
							group.name = res.data.name;
						}
						return group;
					});

					state.commit('setGroups', groups);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	setOrder(state: any, payload: string) {
		state.commit('setOrder', payload);
	},

	setSearch(state: any, payload: string | null) {
		state.commit('setSearch', payload);
	},

	resetOrder(state: any) {
		state.commit('setOrder', initialOrder());
	},

	resetSearch(state: any) {
		state.commit('setSearch', null);
	},
};
